document.addEventListener(
  "DOMContentLoaded",
  () => {
    /** @type {HTMLElement | null} */
    const products_wrapper = document.querySelector(".collection_main_new-products");
    /** @type {HTMLElement | null} */
    const filters_wrapper = document.querySelector(".collection_main_new-filters");
    /** @type {HTMLElement | null} */
    const collection_wrapper = document.querySelector(".collection_main_new-wrapper");
    /** @type {HTMLElement | null} */
    const filterBtn = document.querySelector(".filter-btn");
    if (filterBtn === null) {
      console.error("No filter button found");
      return;
    }
    if (products_wrapper === null) {
      console.error("No products wrapper found");
      return;
    }
    if (filters_wrapper === null) {
      console.error("No filters wrapper found");
      return;
    }
    if (collection_wrapper === null) {
      console.error("No collection wrapper found");
      return;
    }
    filterBtn.addEventListener("click", () => {
      if (collection_wrapper.classList.contains("filters-open")) {
        clearCloseFilters();
      } else {
        products_wrapper.classList.add("hide-items");
        setTimeout(() => {
          collection_wrapper.classList.add("filters-open");
          setTimeout(() => {
            collection_wrapper.classList.add("filters-anim");
            adjustCtaPos();
            products_wrapper.classList.remove("hide-items");
          }, 50);
        }, 300);
      }
    });

    function clearCloseFilters() {
      if (collection_wrapper === null) {
        throw new Error("No collection wrapper found");
      }
      const url = new URL(window.location.href);
      deleteSearchParams(url);
      history.pushState({}, "", url);
      fetchProducts(url.href, true);
      collection_wrapper.classList.remove("filters-anim");
      setTimeout(() => {
        collection_wrapper.classList.remove("filters-open");
      }, 300);
    }

    function clearFilters() {
      const url = new URL(window.location.href);
      deleteSearchParams(url);
      history.pushState({}, "", url);
      fetchProducts(url.href, true);
    }

    function deleteSearchParams(/** @type {URL} */ url) {
      /** @type {string[]} */
      for (const key of [...url.searchParams.keys()]) {
        if (key.includes("filter") || key === "sort_by") {
          url.searchParams.delete(key);
        }
      }
    }

    function getNodeIndex(/** @type {HTMLElement} */ elm) {
      if (elm.parentNode === null) {
        throw new Error("No parent node found");
      }
      return [...elm.parentNode.children].indexOf(elm);
    }

    function adjustCtaPos() {
      if (products_wrapper === null) {
        throw new Error("No products wrapper found");
      }
      // NOTE:
      // We dont have a great way to get this to proper type so we
      // have to use an intermediate `any` for now.
      /** @type {any} */
      const grid_items1 = products_wrapper.children;
      /** @type {HTMLElement[]} */
      const grid_items = Array.from(grid_items1);
      const grid_cols = Number(getComputedStyle(products_wrapper).getPropertyValue("--products-cols"));
      for (const elm of grid_items) {
        if ((getNodeIndex(elm) + 1) % grid_cols === 0 && elm.classList.contains("grid-cols-2")) {
          if (elm.nextElementSibling !== null) {
            elm.nextElementSibling.after(elm);
          }
        }
      }
    }

    adjustCtaPos();

    function attachFilterEvent() {
      if (collection_wrapper === null) {
        throw new Error("No collection wrapper found");
      }
      /** @type {HTMLElement | null} */
      const elm = document.querySelector(".collection_main_new-mobile-controls .apply-btn");
      if (elm === null) {
        console.error("No apply button found");
        return;
      }
      elm.addEventListener("click", () => {
        collection_wrapper.classList.remove("filters-anim");
        setTimeout(() => {
          collection_wrapper.scrollIntoView();
          collection_wrapper.classList.remove("filters-open");
        }, 300);
      });
      const elms2 = document.querySelector(".collection_main_new-mobile-controls .clear-btn");
      if (elms2 === null) {
        console.error("No clear button found");
        return;
      }
      elms2.addEventListener("click", (e) => {
        e.preventDefault();
        setTimeout(() => {
          collection_wrapper.scrollIntoView();
        }, 300);
        clearCloseFilters();
      });
      const elms3 = document.querySelectorAll(".collection_main_new-filter > h3");
      if (elms3 === null) {
        console.error("No filter header found");
        return;
      }
      const clearFilterButton = document.querySelector(".collection_main_new-desktop-controls .clear-btn");
      if (clearFilterButton === null) {
        console.error("No clear button found");
        return;
      }
      clearFilterButton.addEventListener("click", (e) => {
        e.preventDefault();
        setTimeout(() => {
          collection_wrapper.scrollIntoView();
        }, 300);
        clearFilters();
      });
      for (const filter_header of elms3) {
        filter_header.addEventListener("click", (event) => {
          if (event.currentTarget === null) {
            console.error("No current target found");
            return;
          }
          /** @type {any} */
          const targ1 = event.currentTarget;
          /** @type {HTMLElement} */
          const targ = targ1;
          if (targ.parentElement === null) {
            console.error("No parent element found");
            return;
          }
          targ.parentElement.classList.toggle("collapsed");
        });
      }

      const elms4 = document.querySelectorAll(".checkbox-control input");
      if (elms4 === null) {
        console.error("No checkbox inputs found");
        return;
      }
      for (const elm of elms4) {
        elm.addEventListener("change", (e) => {
          if (e.currentTarget === null) {
            console.error("No current target found");
            return;
          }
          /** @type {any} */
          const targ1 = e.currentTarget;
          /** @type {HTMLInputElement} */
          const thisElm = targ1;
          const url = new URL(window.location.href);
          /** @type {{[key: string]: string}} */
          const state = {};
          if (thisElm.name === "price-range") {
            if (thisElm.value !== "0") {
              const range = thisElm.value.split(",");
              url.searchParams.set("filter.v.price.gte", range[0]);
              if (range[1]) {
                url.searchParams.set("filter.v.price.lte", range[1]);
              } else {
                url.searchParams.delete("filter.v.price.lte");
              }
            } else {
              url.searchParams.delete("filter.v.price.gte");
              url.searchParams.delete("filter.v.price.lte");
            }
          } else {
            if (thisElm.checked) {
              if (thisElm.type === "radio") {
                url.searchParams.set(thisElm.name, thisElm.value);
              } else if (thisElm.type === "checkbox") {
                url.searchParams.append(thisElm.name, thisElm.value);
              }
            } else {
              url.searchParams.delete(thisElm.name, thisElm.value);
            }
          }
          url.searchParams.forEach((value, key) => {
            if (state[key] !== undefined) {
              state[key] += `,${value}`;
            } else {
              state[key] = value;
            }
          });
          history.pushState(state, "", url);
          fetchProducts(url.href, true);
        });
      }
    }

    attachFilterEvent();

    window.addEventListener("popstate", (_event) => {
      fetchProducts(window.location.href, true);
    });

    async function fetchProducts(/** @type {string} */ url, /** @type {boolean} */ updateFilters) {
      if (products_wrapper === null) {
        throw new Error("No products wrapper found");
      }
      products_wrapper.classList.add("hide-items");
      const docfetch = await (await cachedFetch(url)).text();
      const domEl = new DOMParser().parseFromString(docfetch, "text/html");
      /** @type {NodeListOf<HTMLElement>} */
      const productCards = domEl.querySelectorAll(".collection_main_new-products > div");
      products_wrapper.innerHTML = "";
      products_wrapper.append(...productCards);
      adjustCtaPos();
      setTimeout(() => {
        products_wrapper.classList.remove("hide-items");
      }, 50);
      if (updateFilters) {
        if (filters_wrapper === null) {
          throw new Error("No filters wrapper found");
        }
        const filters = domEl.querySelectorAll(".collection_main_new-filters > div");
        filters_wrapper.innerHTML = "";
        filters_wrapper.append(...filters);
        attachFilterEvent();
      }
    }
    const cachedMap = new Map();
    function cachedFetch(/** @type {string} */ url, /** @type {RequestInit} */ options = {}) {
      const cacheKey = url;
      if (cachedMap.has(cacheKey)) {
        setTimeout(() => {
          return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
        }, 250);
      }
      return fetch(url, options).then((response) => {
        if (response.status === 200) {
          const contentType = response.headers.get("Content-Type");
          if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
            response
              .clone()
              .text()
              .then((content) => {
                cachedMap.set(cacheKey, content);
              });
          }
        }
        return response;
      });
    }
  },
  false,
);
